import { useState } from "react";

import useLocalization from "../../hooks/useLocalization";
import useBrowser from "../../hooks/useBrowser";

import { Box } from "@mui/material";

import Modal from "./Modal";

import SurveyQuestionEditor from "../editors/SurveyQuestionEditor";
import Dialog_YesNo from "../ui/Dialog_YesNo";

const SurveyQuestionModal = ({
  surveyId,
  surveyPageId,
  surveySectionId,
  question,
  open,
  onClose,
  onSave,
  onDelete,
  onRefresh,
  canDelete = false,
}) => {
  const { getMessage } = useLocalization();
  const { windowHeight } = useBrowser();

  const [changesMade, setChangesMade] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClose = () => {
    if (!changesMade) onClose();

    setOpenDialog(true);
  };

  const handleYes = () => {
    setOpenDialog(false);
    onClose();
  };

  const handleNo = () => {
    setOpenDialog(false);
  };
  return (
    <>
      <Modal
        title={question?.name || "New Question"}
        open={open}
        onClose={handleClose}
        width="600px"
        height={`${windowHeight}px`}
      >
        <SurveyQuestionEditor
          onSave={onSave}
          surveyId={surveyId}
          surveySectionId={surveySectionId}
          question={question}
          changesMade={(newValue) => setChangesMade(newValue)}
          onDelete={onDelete}
          onRefresh={onRefresh}
          canDelete={canDelete}
        />
      </Modal>

      <Dialog_YesNo
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onYes={handleYes}
        onNo={handleNo}
        title={getMessage("cancelChanges")}
        message={getMessage("changesWillBeLost")}
      />
    </>
  );
};

export default SurveyQuestionModal;
